__turbopack_context__.v({
  "content": "creation-workspace-module__2Q9S1q__content",
  "page": "creation-workspace-module__2Q9S1q__page" + " " + __turbopack_context__.i("[project]/apps/web/features/creation/shared/creation.module.css [app-client] (css module)")["page"],
  "workspace": "creation-workspace-module__2Q9S1q__workspace",
  "workspace-enter": "creation-workspace-module__2Q9S1q__workspace-enter",
});
